export const TYPE_DOCUMENT_OPTIONS = [
  'AmpCAC',
  'AnnexesBilan',
  'DepotFonds',
  'AttDom',
  'Autres',
  'Bilan',
  'CessionPart',
  'CompteResultats',
  'ComptesAnnuels',
  'ComptesLiquidation',
  'DeclarationConf',
  'DNC',
  'ImprimeMBE',
  'JDD',
  'JustifSiege',
  'Kbis',
  'LettreAccCac',
  'Liasse',
  'ListeSieges',
  'ListeSouscripteur',
  'JDI',
  'Pouvoir',
  'PvDecision',
  'RapportCac',
  'RapportGestion',
  'StatutsConstitutifs',
  'MajStatuts',
]

export const NOM_DOCUMENT_OPTIONS = [...TYPE_DOCUMENT_OPTIONS, 'Inconnu']

export const STATUT_TECH_OPTIONS = ['ABOUTIE', 'ECHEC', 'REJETEE']

export const DATE_OPERATOR_OPTIONS = [
  { value: 'gt', label: '>' },
  { value: 'gte', label: '>=' },
  { value: 'lt', label: '<' },
  { value: 'lte', label: '<=' },
]

export const DOCUMENT_PER_PAGE_OPTIONS = [10, 20, 50, 100]
